var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Dialog', {
    attrs: {
      "title": "Manage dashboard",
      "show": _vm.isOpen,
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('el-form', {
    attrs: {
      "inline": "",
      "size": "small"
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "placeholder": "Report"
    },
    model: {
      value: _vm.selectedReport,
      callback: function ($$v) {
        _vm.selectedReport = $$v;
      },
      expression: "selectedReport"
    }
  }, _vm._l(_vm.reports, function (r) {
    return _c('el-option', {
      key: r.id,
      attrs: {
        "label": r.name,
        "value": r.id
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": _vm.addReportToDashboard
    }
  }, [_vm._v(" Add ")])], 1)], 1), _c('el-button', {
    attrs: {
      "type": "primary",
      "round": "",
      "icon": "el-icon-plus",
      "size": "small"
    },
    on: {
      "click": _vm.newReport
    }
  }, [_vm._v("New report")])], 1), _c('Table', {
    attrs: {
      "items": _vm.dashboard.reports || [],
      "columns": _vm.columns,
      "actions": _vm.actions,
      "filterProp": "name",
      "loading": _vm.loading.dashboard
    }
  }), _c('ReportDialog', {
    attrs: {
      "item": _vm.item,
      "isOpen": _vm.showEditDialog,
      "onClose": function () {
        return _vm.showEditDialog = false;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }